// declare var moment: any;

import * as moment_ from '../utilities/lib-moment/moment-with-locales.custom.min';
const moment = moment_;

export class DateRangeFormatter {
  public format(date: Date, format: string): string {
    return moment(date).format(format);
  }

  public fixTimeZone(date: Date): Date {
    const hours = date.getHours();
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      hours === 23 ? hours + 2 : 0
    );
  }
}
